const wall = [
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','#','#','#','#','#','#','#','#','#','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','-','-','-','-'],
    ['-','-','-','-','-','-','#','#','#','#','#','#','#','#','#','#','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
];


const mrmap = [
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','#','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','#','#','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','#','#','#','-','-','-','-','-','-'],
    ['-','-','-','-','#','#','-','-','-','#','#','-','-','#','#','-','-','-','-','-'],
    ['-','-','-','-','#','#','#','-','#','#','#','-','-','-','#','-','-','-','-','-'],
    ['-','-','-','-','#','-','#','#','#','-','#','-','-','-','#','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','#','-','-','#','-','-','#','#','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','#','#','#','-','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','-','#','-','-','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','-','#','#','-','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','-','-','#','-','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','-','-','#','#','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','-','-','-','#','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','-','-','-','#','-','-','-','-','-'],
    ['-','-','-','-','#','-','-','-','-','-','#','-','-','-','#','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
    ['-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-','-'],
]

const something = [
    ['-','-','-','-','-','-','#','-','-','-','-','-','-','-','-','-','#','-','-','-'],
    ['-','-','-','-','-','-','#','-','-','-','-','-','-','-','-','-','#','-','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','#','#','-','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','#','-','-','#','-'],
    ['-','-','-','#','-','-','#','#','#','#','#','-','#','-','-','#','-','-','#','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','#','-','#','#','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','#','-','#','-','-'],
    ['-','-','-','#','-','-','#','-','#','#','#','#','#','-','-','-','-','#','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','#','#','#','#','#','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','-','-','-','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','-','-','-','-','-'],
    ['-','-','-','#','-','-','#','#','#','#','#','-','#','-','-','-','-','-','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','-','-','-','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','#','#','#','#','#','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','-','#','-','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','-','#','-','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','-','#','-','-','-'],
    ['-','-','-','#','-','-','#','-','-','-','-','-','#','-','-','-','#','-','-','-'],
    ['-','-','-','#','-','-','-','-','-','-','-','-','#','-','-','-','#','-','-','-'],
    ['-','-','-','#','-','-','-','-','-','-','-','-','#','-','-','-','-','-','-','-'],
]

export const maps = {
    wall,
    mrmap,
    something
}